import { M1TestShackSheetPage } from "./M1TestShackSheetPage";

export default M1TestShackSheetPage;
